/*
 * Copyright (c) 2023 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { HttpClient, HttpErrorResponse, HttpParams, HttpStatusCode } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})

export class ManageAllScenariosWithAssociationsService {

  constructor(private readonly configService: ConfigService,
              private readonly http: HttpClient) {
  }

  /**
   * Sends a get request to retrieve list of all scenarios with associations
   */
  getAllScenariosWithAssociations(): any {
    return this.http.get<any[]>(`${this.configService.baseApiUrl}manage-scenarios/associations`)
    .pipe(catchError(myError => this.handleError(myError)));
  }

  /**
   * Sends a delete request to delete a list of scenarios
   * @param scenarioIdList list of scenario ids to be deleted
   * @param scenarioType scenario type to be deleted
   * @param existsInVehicleScenario boolean to check if propulsion scenario exists in vehicle scenario
   */
  deleteScenarios(scenarioIdList: number[], scenarioType: string, existsInVehicleScenario: boolean): Observable<any> {
    const params = new HttpParams().set('scenarioType', scenarioType).set('existsInVehicleScenario', existsInVehicleScenario);
    return this.http.delete(`${this.configService.baseApiUrl}manage-scenarios`,
      {params, body: scenarioIdList})
    .pipe(catchError(myError => this.handleError(myError)));
  }

  /**
   * Handles the errors produced by the backend
   * @param errorResponse The error produced by the API to be handled by the frontend
   * @return void
   */
  handleError(errorResponse: HttpErrorResponse): any {
    let errorMessage = 'An unexpected error occurred.';
    switch (errorResponse.status) {
      case HttpStatusCode.BadRequest: {
        if (errorResponse.error && errorResponse.error.message) {
          errorMessage = errorResponse.error.message;
        }
        break;
      }
    }
    return throwError(errorMessage);
  }
}
